var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", md8: "", "offset-md1": "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _c("h4", [_vm._v("Orders")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            color: "primary",
                            loading: _vm.ordersLoading,
                            disabled: _vm.ordersLoading,
                            fab: "",
                            flat: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.searchOrders()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("refresh")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-data-table",
                        {
                          attrs: {
                            id: "orderTable",
                            headers: _vm.headers,
                            items: _vm.orders,
                            loading: _vm.ordersLoading,
                            pagination: _vm.pagination,
                            "total-items": _vm.totalOrders,
                            "rows-per-page-items": _vm.rowsPerPageItems
                          },
                          on: {
                            "update:pagination": function($event) {
                              _vm.pagination = $event
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c(
                                    "tr",
                                    {
                                      class:
                                        props.item.onlyMotorAccessories === 1
                                          ? "onlyMotorAccessories"
                                          : ""
                                    },
                                    [
                                      _vm.editDeleteAllowed
                                        ? _c(
                                            "td",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    flat: "",
                                                    color: "primary",
                                                    target: "_blank",
                                                    to:
                                                      "/order/" + props.item._id
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.orderCode)
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _c("td", [
                                            _vm._v(_vm._s(props.item.orderCode))
                                          ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                flat: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.selectOrder(
                                                    props.item._id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  props.item.customerID
                                                    ? props.item.customerID
                                                        .firstName +
                                                        " " +
                                                        props.item.customerID
                                                          .lastName
                                                    : ""
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      props.item.updatedBy
                                        ? _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                props.item.updatedBy.firstName
                                              )
                                            )
                                          ])
                                        : props.item.createdBy
                                        ? _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                props.item.createdBy.firstName
                                              )
                                            )
                                          ])
                                        : _c("td", [_vm._v("Online")]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          "$" +
                                            _vm._s(
                                              props.item.subTotal.toFixed(2)
                                            )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            new Date(
                                              props.item.date
                                            ).getDate() +
                                              "/" +
                                              (new Date(
                                                props.item.date
                                              ).getMonth() +
                                                1) +
                                              "/" +
                                              new Date(
                                                props.item.date
                                              ).getFullYear()
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            props.item.install > 0
                                              ? "Install"
                                              : "Delivery"
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.availableStatuses,
                                              label: "Status"
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.updateStatus(
                                                  props.item._id,
                                                  props.item.status
                                                )
                                              }
                                            },
                                            model: {
                                              value: props.item.status,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "props.item.status"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.actionItems(props),
                                              label: "Actions"
                                            },
                                            on: { change: _vm.orderActions }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c("v-progress-linear", {
                            attrs: {
                              slot: "progress",
                              color: "primary",
                              indeterminate: ""
                            },
                            slot: "progress"
                          }),
                          _vm._v(" "),
                          _vm._v(" "),
                          _c("template", { slot: "no-data" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.loadingText) +
                                "\n            "
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md2: "" } },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_c("h4", [_vm._v("Search and Filter")])]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.availableStatuses,
                          chips: "",
                          clearable: "",
                          label: "Filter Status",
                          multiple: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.searchOrders()
                          }
                        },
                        model: {
                          value: _vm.enabledStatuses,
                          callback: function($$v) {
                            _vm.enabledStatuses = $$v
                          },
                          expression: "enabledStatuses"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.availableUsers,
                          label: "Filter Users",
                          "item-value": "id",
                          "item-text": "firstName",
                          multiple: "",
                          chips: "",
                          clearable: "",
                          "menu-props": "bottom"
                        },
                        on: {
                          input: function($event) {
                            return _vm.searchOrders()
                          }
                        },
                        model: {
                          value: _vm.enabledUsers,
                          callback: function($$v) {
                            _vm.enabledUsers = $$v
                          },
                          expression: "enabledUsers"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "search",
                          label: "Search",
                          "single-line": "",
                          "hide-details": ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.searchOrders()
                          }
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-spacer", { staticClass: "v-text-field" }),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.availableInstallorDelivery,
                          chips: "",
                          clearable: "",
                          label: "Filter Order Type",
                          multiple: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.searchOrders()
                          }
                        },
                        model: {
                          value: _vm.enabledInstallorDelivery,
                          callback: function($$v) {
                            _vm.enabledInstallorDelivery = $$v
                          },
                          expression: "enabledInstallorDelivery"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-spacer", { staticClass: "v-text-field" }),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.availableOnlineorOffline,
                          chips: "",
                          clearable: "",
                          label: "Filter Online / Offline",
                          multiple: ""
                        },
                        on: {
                          input: function($event) {
                            return _vm.searchOrders()
                          }
                        },
                        model: {
                          value: _vm.enabledOnlineorOffline,
                          callback: function($$v) {
                            _vm.enabledOnlineorOffline = $$v
                          },
                          expression: "enabledOnlineorOffline"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { width: "500" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "headline grey lighten-2",
                      attrs: { "primary-title": "" }
                    },
                    [_vm._v("\n          Download CM\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    _vm._l(_vm.CMs, function(CM, index) {
                      return _c(
                        "div",
                        { key: "bb" + index, staticClass: "level" },
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-xl": "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", sm6: "" } },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "level-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.downloadCheckMeasure(
                                                CM.file
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(CM.file))]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", text: "" },
                          on: {
                            click: function($event) {
                              _vm.dialog = false
                            }
                          }
                        },
                        [_vm._v("\n            Close\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { dark: "", top: "", timeout: 3000 },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.popupText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.customerDialog,
            callback: function($$v) {
              _vm.customerDialog = $$v
            },
            expression: "customerDialog"
          }
        },
        [
          _vm.selectedOrder
            ? _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      _vm._s(_vm.selectedOrder.orderCode) +
                        " - Customer Details"
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c("p", [
                      _vm._v(
                        "Name: " +
                          _vm._s(_vm.selectedOrder.customerID.firstName) +
                          " " +
                          _vm._s(_vm.selectedOrder.customerID.lastName)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Phone: " + _vm._s(_vm.selectedOrder.customerID.phone)
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Email: " + _vm._s(_vm.selectedOrder.customerID.email)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.customerDialog = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            flat: "",
                            target: "_blank",
                            to: "/customers/" + _vm.selectedOrder.customerID._id
                          }
                        },
                        [_vm._v("Go to Customer")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400px" },
          model: {
            value: _vm.confirmDialog,
            callback: function($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog"
          }
        },
        [
          _vm.selectedOrder
            ? _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v("Please confirm")]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _c("p", [
                      _vm._v("Are you sure you want to delete "),
                      _c("b", [_vm._v(_vm._s(_vm.selectedOrder.orderCode))]),
                      _vm._v("?")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", flat: "" },
                          on: {
                            click: function($event) {
                              _vm.confirmDialog = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.deleteOrder(_vm.selectedOrder._id)
                            }
                          }
                        },
                        [_vm._v("Delete")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "300" },
          model: {
            value: _vm.twcOrderCheck,
            callback: function($$v) {
              _vm.twcOrderCheck = $$v
            },
            expression: "twcOrderCheck"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", [
                _c("h3", [
                  _vm._v(
                    "This order number has already sent to TWC - do you want to continue?"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "primary" },
                        nativeOn: {
                          click: function($event) {
                            _vm.openTwcScreen("" + _vm.selectedOrderId),
                              (_vm.twcOrderCheck = false)
                          }
                        }
                      },
                      [_vm._v(" Yes ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "primary" },
                        on: {
                          click: function($event) {
                            _vm.twcOrderCheck = false
                          }
                        }
                      },
                      [_vm._v(" No ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0323b3e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0323b3e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/Orders.vue
// module id = null
// module chunks = 